import { PageNames, TNavbarPage, useEnvironment } from '@diana/core';
import { useMemo } from 'react';
import { routeUrls } from '../app/Routing/RouteUrls';
import { useNavMenuItems } from './useNavMenuItems';
import { useIsActiveNavMenuItem } from './useIsActiveNavMenuItem';

export function useNavMenuPages() {
  const environment = useEnvironment();
  const { getNavMenuLabel, getNavMenuTarget, isNavMenuHidden, getExternalLinks } =
    useNavMenuItems();
  const isActiveNavMenu = useIsActiveNavMenuItem();
  const pages: TNavbarPage[] = useMemo(() => {
    return [
      {
        path: routeUrls.home.url({ environment }, {}),
        label: getNavMenuLabel('home'),
        hide: isNavMenuHidden('home'),
        target: getNavMenuTarget('home'),
        pageName: PageNames.HOME,
        dataTestId: 'home-nav',
      },
      {
        path: routeUrls.workflows.url({ environment }, {}),
        label: getNavMenuLabel('work'),
        hide: isNavMenuHidden('work'),
        target: getNavMenuTarget('work'),
        pageName: PageNames.WORKFLOWS,
        dataTestId: 'work-nav',
      },
      {
        path: routeUrls.performance.url({ environment }, null),
        label: getNavMenuLabel('performance'),
        hide: isNavMenuHidden('performance'),
        target: getNavMenuTarget('performance'),
        pageName: PageNames.PERFORMANCE,
        dataTestId: 'performance-nav',
      },
      {
        path: routeUrls.people.url({ environment }, null),
        label: getNavMenuLabel('people'),
        hide: isNavMenuHidden('people'),
        target: getNavMenuTarget('people'),
        pageName: PageNames.PEOPLE,
        dataTestId: 'people-nav',
      },
      {
        path: routeUrls.thingsGroups.url({ environment }, null),
        label: getNavMenuLabel('assets'),
        hide: isNavMenuHidden('assets'),
        target: getNavMenuTarget('assets'),
        pageName: PageNames.THING_TYPES,
        dataTestId: 'assets-nav',
      },
      ...getExternalLinks(),
    ].filter((item) => !item.hide);
  }, [environment, getNavMenuLabel, getNavMenuTarget, getExternalLinks, isNavMenuHidden]);

  return { pages, isActive: isActiveNavMenu };
}
